import { Link } from "react-router-dom";
import { categories } from "@/mocks/content";

const icons: Record<string, string> = {
  love: "ri-heart-3-line",
  collapse: "ri-emotion-unhappy-line",
  livestream: "ri-live-line",
  selling: "ri-shopping-bag-3-line",
  variety: "ri-movie-2-line",
  business: "ri-line-chart-line",
};

export default function CategoryStrip() {
  return (
    <section aria-labelledby="category-title" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-10">
        <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 id="category-title" className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              按类型找瓜
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              六大瓜料分类，想围观哪一类点哪一类
            </p>
          </div>
          <Link
            to="/news"
            className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors duration-200 hover:text-primary-700"
          >
            全部瓜料
            <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/topic/${category.slug}`}
              className="group flex flex-col gap-3 rounded-lg border border-background-200/80 bg-background-100/60 p-4 transition-colors duration-200 hover:border-accent-400 hover:bg-accent-50"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-800 transition-colors duration-200 group-hover:bg-accent-500 group-hover:text-background-50">
                <i className={`${icons[category.slug]} text-xl`} aria-hidden="true" />
              </span>
              <span>
                <span className="block font-heading text-sm font-bold text-foreground-950">
                  {category.name}
                </span>
                <span className="mt-1 block text-xs text-foreground-500">
                  {category.count} 条瓜料
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}